import { render, staticRenderFns } from "./interactive-info-detail.vue?vue&type=template&id=66606728&"
import script from "./interactive-info-detail.vue?vue&type=script&lang=js&"
export * from "./interactive-info-detail.vue?vue&type=script&lang=js&"
import style0 from "./interactive-info-detail.vue?vue&type=style&index=0&id=66606728&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports